module.exports = __webpack_public_path__ + "static/media/detail_0017_t.37dae935.jpg";